import { FormikValues, useFormikContext } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';

import Icone from 'Component/Icone';

import Ajuda from './Ajuda';
import Grupo from './Grupo';

interface Props {
    name: string;
    notaMaxima?: number;
    ajuda?: string;
}

const Avaliacao = ({ ajuda, name, notaMaxima = 5 }: Props): React.ReactElement =>
{
    const [ selecionado, setSelecionado ] = useState<number>(0);
    const [ passouPorCima, setPassouPorCima ] = useState<number>(0);
    const { errors, touched, setFieldTouched, setFieldValue, values } = useFormikContext<FormikValues>();

    const estrelas: Array<number> = useMemo(() => {
        const estrelas: Array<number> = [];

        for (let i = 1; i <= notaMaxima; i++) {
            estrelas.push(i);
        }

        return estrelas;
    }, [notaMaxima]);

    useEffect(() => {
        setSelecionado(values[name]);
    }, [values, name])

    const alterarEstado = (estrela: number): void =>
    {
        setPassouPorCima(estrela);
    }

    const selecionar = (estrela: number): void =>
    {
        setSelecionado(estrela);
        setFieldTouched(name, true);
        setFieldValue(name, estrela, true);
    }

    return (
        <Grupo emLinha={ false }>
            <div className="d-flex justify-content-center">
                { estrelas.map(estrela => (
                    <button
                        key={ estrela.toString() }
                        type="button"
                        className={[
                            'btn btn-transparent fs-1 opacity-25',
                            errors[name]
                                && touched[name]
                                && 'text-danger',
                            (estrela <= passouPorCima || estrela <= selecionado)
                                && 'opacity-100'
                        ].className()}
                        onClick={ () => selecionar(estrela) }
                        onMouseEnter={ () => alterarEstado(estrela) }
                        onMouseLeave={ () => alterarEstado(0) }
                    >
                        <Icone
                            nome="star-fill"
                            className={[
                                (estrela <= passouPorCima || estrela <= selecionado)
                                    && 'text-warning'
                            ].className()}
                        />
                    </button>
                )) }
                <React.Fragment>
                    { ajuda && (
                        <Ajuda>{ ajuda }</Ajuda>
                    ) }
                </React.Fragment>
            </div>
            <React.Fragment>
                { errors[name] && touched[name] && (
                    <div
                        className={[
                            'position-absolutetop-100 start-50 translate-middle',
                            'invalid-tooltip',
                            'd-inline-block',
                        ].className()}
                    >
                        { errors[name] && touched[name] && errors[name] }
                    </div>
                ) }
            </React.Fragment>
        </Grupo>
    )
}

export default Avaliacao;
